import { moreTooltipper, None } from 'components/data/helpers';
import { Tag } from 'components/ui';

export const AuxiliaryComponentList = ({ auxiliaryComponents = [], compact }) => {
  if (!auxiliaryComponents.length) {
    return <None />;
  }

  const pills = auxiliaryComponents.map(aux => (
    <Tag data-testid="tag" key={aux.id}>
      {aux.name}
    </Tag>
  ));

  if (compact) {
    return moreTooltipper(auxiliaryComponents.map(aux => aux.name));
  }
  return <>{pills}</>;
};
